/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
import { Brand, Page, PageHeader, PageSection } from '@patternfly/react-core';

import { Atlasmap, useAuth } from '@atlasmap/atlasmap';
import React from 'react';
import atlasmapLogo from './logo-horizontal-darkbg.png';

const App: React.FC = () => {
  const authContext = useAuth();

  // Optional: Cleanup tokens on window unload
  React.useEffect(() => {
    const handleBeforeUnload = () => {
      authContext.clearTokens();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [authContext]);

  return (
    <Page
      header={
        <PageHeader
          logo={
            <>
              <Brand
                src={atlasmapLogo}
                alt="AIP Data Mapper UI"
                height="40"
              />
            </>
          }
          style={{ minHeight: 40, display: "none" }}
        />
      }
    >
      {/* <Banner variant="warning" isSticky={true} style={{ textAlign: 'center' }}> Please save the changes periodically, to avoid re-mapping. </Banner> */}
      {/* {showEntry && <EntryScreen showEntryM={setShowEntry} data={data} setData={setData} />} */}
      <PageSection
        variant={'light'}
        padding={{ default: 'noPadding' }}
        isFilled={true}
      >
        <Atlasmap allowReset={false} />
      </PageSection>
    </Page >
  );
};

export default App;
